import styled from 'styled-components/macro'

export const SearchForm = styled.form`
  margin-top: 0.5rem;
`

export const SearchInput = styled.input`
  float: left;
  padding: 0.4rem;
  margin-top: 0.5rem;
  border-radius: 0.2rem 0 0 0.2rem;
  border: 1px solid #0d65d3;
  height: 2.4rem;
  width: calc(100% - 2.5rem);

  &:focus {
    outline: none !important;
    border-color: #80d5dc;
    box-shadow: 0 0 0.5rem #80d5dc;
  }
`
export const SearchButton = styled.button`
  padding: 0.5rem;
  margin: 0.5rem 0;
  background: #224fac;
  border-radius: 0 0.2rem 0.2rem 0;
  border: 1px solid #224fac;
  border-left: none;
  cursor: pointer;
  width: 2.5rem;
  height: 2.4rem;

  &:hover {
    background: #072558;
    border: 1px solid #072558;
  }
`
